import { OrderHeaderURLs } from '../../../baseComponents/TwinTable/InputTableLayout/types'

const useAdjustmentDeliveryNoteHeaderURLs = () => {
    const orderHeaderURLs: OrderHeaderURLs = {
        createCost: '',
        updateCost: '',
        deleteCost: '',
        createFinancialRow: '',
        updateFinancialRow: '',
        deleteFinancialRow: '',
        createAccount: '',
        updateAccount: '',
        deleteAccount: '',
        createShipping: '',
        updateShipping: '',
        createVariable: '',
        updateVariable: '',
        deleteVariable: '',
        updateWorkingCenter: '/api/app/order/adjustmentDeliveryNote/updateAdjustmentDeliveryNoteWorkingCenter',
        createUpdateProductTypes: '/api/app/order/adjustmentDeliveryNote/orderProductType/createUpdateAdjustmentDeliveryNoteProductTypes',
    }
    return orderHeaderURLs
}

export default useAdjustmentDeliveryNoteHeaderURLs